<template>
	<v-container class="py-7">
		<v-row>
			<v-col :cols="12">
				<div class="title-container">
					<div class="title-block">
						<span id="title" class="page-title">Habilitações/Divergências</span>
						<v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
							{
								text: 'Homepage',
								disabled: false,
								to: '/home',
								exact: true,
							},
							{
								text: 'Habilitações/Divergências',
								disabled: true,
								exact: true,
							},
						]"></v-breadcrumbs>
					</div>


					<div class="button-group">
						<v-menu offset-y transition="slide-y-reverse-transition">
							<template #activator="{ on, attrs }">
								<v-tooltip bottom>
									<template #activator="{ on: tooltipOn }">
										<v-btn v-bind="attrs" v-on="{ ...on, ...tooltipOn }" id="btnNewDropdown"
											type="button" color="primary" elevation="0" class="btn-dropdown">
											Análise
										</v-btn>
									</template>
									<span>Selecione o tipo de análise</span>
								</v-tooltip>
							</template>

							<v-list>
								<v-list-item to="/divergencias-analise" link class="menu-item"
									title="Analise habilitação / divergência">
									<v-list-item-icon>
										<v-icon>mdi-text-box-search-outline</v-icon>
									</v-list-item-icon>
									<v-list-item-title>Pedido</v-list-item-title>
								</v-list-item>

								<v-list-item to="/divergencias-business-analise" link class="menu-item"
									title="Analise negócio">
									<v-list-item-icon>
										<v-icon>mdi-briefcase-search-outline</v-icon>
									</v-list-item-icon>
									<v-list-item-title>Negócio</v-list-item-title>
								</v-list-item>
							</v-list>
						</v-menu>
					</div>
				</div>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12">
				<v-card class="filter-card">
					<v-card-title class="filter-card-title">Filtro</v-card-title>
					<v-card-text>
						<v-form @submit.prevent="load()">
							<v-row>
								<v-col>
									<v-text-field dense id="name" label="Nome" v-model="dataList.filter.name"
										hide-details outlined></v-text-field>
								</v-col>
								<v-col>
									<v-text-field dense id="registration" label="CPF/CNPJ"
										v-model="dataList.filter.registration" hide-details outlined></v-text-field>
								</v-col>
								<v-col>
									<v-select dense :items="dataset.eventStatus" label="Status"
										v-model="dataList.filter.status" item-value="id" item-text="name" outlined
										hide-details="auto">
									</v-select>
								</v-col>
								<v-col>
									<v-select dense :items="dataset.eventTypes" label="Tipo"
										v-model="dataList.filter.type" item-value="id" item-text="name" outlined
										hide-details="auto">
									</v-select>
								</v-col>
							</v-row>
							<v-row>
								<v-col cols="12">
									<v-btn id="btnFilter" type="submit" color="primary" dark
										elevation="2">Filtrar</v-btn>
								</v-col>
							</v-row>
						</v-form>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12">
				<v-card class="table-card">
					<v-card-title class="table-card-title">Hab/Div
						<v-spacer></v-spacer>
						<div class="icon-container">
							<v-tooltip bottom>
								<template #activator="{ on }">
									<v-icon icon v-on="on" @click="showModal = true" size="x-large">
										mdi-microsoft-excel
									</v-icon>
								</template>
								<span>Exportar dados para CSV</span>
							</v-tooltip>
						</div>
					</v-card-title>
					<v-card-text>
						<v-data-table :headers="dataList.headers" :items="dataList.data"
							:server-items-length="dataList.count" @update:items-per-page="pageSizeChanged"
							@update:page="pageChanged" :disable-sort="true" :loading="dataList.loading"
							no-data-text="Nenhum usuário foi encontrado" loading-text="Carregando dados..."
							class="app-table hover-table" :options.sync="dataList.options"
							:footer-props="dataList.footerOptions">
							<template v-slot:[`item.user.name`]="{ item }">
								<span class="list-item-title text-capitalize">{{ item.user.name }}</span><br />
							</template>

							<!-- <template v-slot:[`item.status`]="{ item }">
								<v-chip :color="getColorByStatus(item.status)" label text-color="white">
									{{ item.status | enum(dataset.eventStatus, "id", "name") }}
								</v-chip>
							</template> -->

							<template v-slot:[`item.status`]="{ item }">
								<v-chip small class="text-uppercase font-weight-bold text-caption"
									:color="getChipColor(item)" label text-color="white">
									{{ getChipLabel(item) }}
								</v-chip>
							</template>

							<template v-slot:[`item.type`]="{ item }">
								{{ item.type == 2 ? 'Divergência' : 'Habilitação' }}
							</template>

							<template v-slot:[`item.enable_contradictory`]="{ item }">
								<span v-if="item.enable_contradictory == 2">
									{{ item.contradictory_deadline_at | defaultDate('DD/MM/YYYY') }}
								</span>
								<span v-else>Fechado</span>
							</template>


							<template v-slot:[`item.created_at`]="{ item }">
								{{ item.created_at | defaultDate("DD/MM/YYYY HH:mm:ss") }}
							</template>

							<template v-slot:[`item.actions`]="{ item }">
								<v-tooltip bottom>
									<template #activator="{ on }">
										<v-icon icon v-on="on" :disabled="!$check('users/1', ['PATCH'])"
											@click="viewItem(item)" size="large" class="me-2">
											mdi-pencil-outline
										</v-icon>
									</template>
									<span>Editar informações da habilitação / divergência</span>
								</v-tooltip>
							</template>
						</v-data-table>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>

		<!-- Modal -->
		<v-dialog v-model="showModal" max-width="600px">
			<v-card>
				<v-card-title class="text-center text--darken-2"
					style="border-bottom: 4px solid #007bff; padding-bottom: 8px; display: flex; justify-content: center; align-items: center;">
					FILTRAR DADOS
				</v-card-title>
				<br>
				<v-card-text>

					<p>Selecione a data inicial e data final para fazer a busca dos dados</p>

					<v-form ref="filterForm" @submit.prevent="loadCsvData">

						<v-row>
							<v-col cols="12" md="6">
								<v-menu v-model="menuStart" :close-on-content-click="false" :nudge-right="40"
									transition="scale-transition" offset-y min-width="290px">
									<template #activator="{ on, attrs }">
										<v-text-field v-model="formattedStartDate" label="Data Inicial"
											prepend-icon="mdi-calendar" v-bind="attrs" v-on="on"
											@blur="updateStartDate"></v-text-field>
									</template>
									<v-date-picker v-model="csvFilters.startDate" locale="pt-BR" scrollable
										@input="formatStartDate" @change="menuStart = false"></v-date-picker>
								</v-menu>
							</v-col>

							<v-col cols="12" md="6">
								<v-menu v-model="menuEnd" :close-on-content-click="false" :nudge-right="40"
									transition="scale-transition" offset-y min-width="290px">
									<template #activator="{ on, attrs }">
										<v-text-field v-model="formattedEndDate" label="Data Final"
											prepend-icon="mdi-calendar" v-bind="attrs" v-on="on"
											@blur="updateEndDate"></v-text-field>
									</template>
									<v-date-picker v-model="csvFilters.endDate" locale="pt-BR" scrollable
										@input="formatEndDate" @change="menuEnd = false"></v-date-picker>
								</v-menu>
							</v-col>
						</v-row>

						<v-row>
							<v-col cols="12">
								<v-checkbox v-model="csvFilters.importantCreditors" label="Somente credores importantes"
									outlined></v-checkbox>
							</v-col>
						</v-row>

						<v-row>
							<v-spacer></v-spacer>
							<v-btn text color="grey" @click="showModal = false">Cancelar</v-btn>
							<v-btn color="primary" type="submit" :loading="loadingExport">Filtrar</v-btn>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>

	</v-container>
</template>

<script>

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';

import object from "@/common/util/object"
import eventStatus from "@/common/data/event-status.data";

import { cpf, cnpj } from 'cpf-cnpj-validator'

import creditorTypes from "@/common/data/creditor-types.data"

Vue.use(VueLodash)

export default {
	name: "UserList",

	data: () => ({
		dataset: {
			eventStatus: [{ id: "", name: "Todos" }, ...eventStatus],
			eventTypes: [{ id: "", name: "Todos" }, { id: 1, name: "Habilitação" }, { id: 2, name: "Divergência" }],
			creditorTypes: creditorTypes,
			data: {}
		},
		showModal: false,
		menuStart: false,
		menuEnd: false,
		formattedStartDate: "",
		formattedEndDate: "",
		csvFilters: {
			startDate: null,
			endDate: null,
			importantCreditors: false,
		},

		loadingExport: false,

		dataList: {
			filter: {
				name: "",
				status: "",
				type: ""
			},
			headers: [
				{ text: "ID", value: "id" },
				{ text: "Credor", value: "user.name" },
				{ text: "Tipo", value: "type" },
				{ text: "Status", value: "status" },
				{ text: "Solicitado em", value: "created_at" },
				{ text: "Prazo contraditório", value: "enable_contradictory" },
				{ text: 'Ações', value: 'actions', sortable: false },
			],
			data: [],
			loading: false,
			count: 0,
			options: {
				page: 1,
				itemsPerPage: 50,
				sortBy: ['name'],
				sortDesc: [false],
			},
			footerOptions: {
				itemsPerPageText: 'Itens por página:',
				itemsPerPageOptions: [10, 20, 30, 40, 50],
			}
		},
	}),

	created() {
		this.load();
	},

	methods: {
		clientPageText() {
			return `${this.dataList.paging.page} de ${this.dataList.paging.pages}`;
		},

		pageChanged(page) {
			this.dataList.paging.page = page;
			this.list();
		},

		pageSizeChanged(size) {
			this.dataList.paging.size = size;
			this.list(true);
		},

		getColorByStatus(status) {
			switch (status) {
				case 0:
					return 'warning';
				case 1:
					return 'accent';
				case 2:
					return 'error';
				case 3:
					return 'indigo darken-1';
				default:
					return 'grey';
			}
		},

		getChipColor(item) {
			if (item.currentReview && item.currentReview.status == 0) {
				return "#9FA8DA";
			}

			if (item.status == 4) {
				return "#7E55AB";
			}

			if (item.status == 5) {
				return "#29B6F6";
			}

			return this.getColorByStatus(item.status);
		},

		getChipLabel(item) {
			if (item.currentReview && item.currentReview.status == 0) {
				return "Em análise";
			}

			return this.enum(item.status, this.dataset.eventStatus, "id", "name");
		},

		enum(status, eventStatus, idKey, nameKey) {
			const matchedStatus = eventStatus.find((e) => e[idKey] === status);
			return matchedStatus ? matchedStatus[nameKey] : 'Desconhecido';
		},

		debounce: _.debounce(function () {
			this.reload();
		}, 500),

		reload: function () {
			this.load();
		},

		formatDate(date) {
			if (!date) return "";
			const [year, month, day] = date.split("-");
			return `${day}/${month}/${year}`;
		},

		parseDate(date) {
			if (!date) return null;
			const [day, month, year] = date.split("/");
			return `${year}-${month}-${day}`;
		},

		formatStartDate(date) {
			this.formattedStartDate = this.formatDate(date);
		},

		formatEndDate(date) {
			this.formattedEndDate = this.formatDate(date);
		},

		updateStartDate() {
			this.csvFilters.startDate = this.parseDate(this.formattedStartDate);
		},

		updateEndDate() {
			this.csvFilters.endDate = this.parseDate(this.formattedEndDate);
		},

		async load() {

			let search = Object.fromEntries(Object.entries(this.dataList.filter).filter(([_, v]) => v))

			search = !object.isEmpty(search) ? search : null;

			this.dataList.loading = true;

			var limit = this.dataList.options.itemsPerPage;
			var start = (this.dataList.options.page - 1) * limit;

			try {
				const result = await axios.get('/api/admin/user-events/client/list', { params: { start: start, limit: limit, search: search } });

				this.dataList.data = result.data.content.data;
				this.dataList.count = result.data.count;

			} catch (error) {
				this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
			} finally {
				this.dataList.loading = false;
			}

		},

		viewItem(item) {
			this.$router.push(`divergencias/${item.id}`);
		},

		async loadCsvData() {

			if (!this.formattedStartDate || !this.formattedEndDate) {
				this.$dialog.notify.error("Por favor selecione uma data inicial e outra final", { position: 'top-right', timeout: 5000 });
				return;
			}

			const [startDay, startMonth, startYear] = this.formattedStartDate.split("/").map(Number);
			const [endDay, endMonth, endYear] = this.formattedEndDate.split("/").map(Number);
			const startDate = new Date(startYear, startMonth - 1, startDay);
			const endDate = new Date(endYear, endMonth - 1, endDay);

			if (startDate > endDate) {
				this.$dialog.notify.error("A data final deve ser igual ou maior que a data inicial", {
					position: 'top-right',
					timeout: 5000
				});
				return;
			}

			const proceedAction = await this.$dialog.confirm({
				text: 'Deseja exportar os dados para CSV?',
				title: 'Exportar dados',
				actions: {
					false: 'Cancelar',
					true: 'Exportar'
				}
			})

			if (!proceedAction) return;

			try {

				this.loadingExport = true;

				const result = await axios.get('/api/admin/user-events/client/list/details', { params: { limit: 100000000, search: { start: startDate, end: endDate, important: this.csvFilters.importantCreditors } } });

				if (result.data.content.data.length == 0) {
					this.$dialog.notify.error("Sem dados para gerar arquivo CSV!", { position: "top-right", timeout: 2000 });

					return;
				}

				let newData = [];

				for (let item of result.data.content.data) {

					for (let [i, value] of item.items.entries()) {

						let docNames = (value.docs || [])
							.map(docItem => {
								return docItem.doc && docItem.doc.name ? docItem.doc.name : '';
							})
							.filter(name => name)
							.join(', ');

						let data = {
							"NR ORDEM": item.id,
							"NEGOCIO": `#${i + 1}`,
							"ID NEGOCIO": `#${value.id}`,
							"CREDOR": item.user.name.toLowerCase(),
							"CPF/CNPJ": this.formatCpfCnpj(item.user.registration),
							"TIPO": item.user.creditor ? "Divergência" : "Habilitação",
							"STATUS": (eventStatus.find(status => status.id === value.status) || { name: "N/A" }).name,
							"PROCESSO": item.processes.length ? 'Sim' : 'Não',
							"NR PROCESSOS": item.processes.length ? item.processes.map((x) => x.number.replaceAll(";", '')).join(', ') : 'N/A',
							"VALOR SOLICITADO": parseFloat(item.items.reduce((total, item) => total + (item.amount || 0), 0).toString()).toFixed(2),
							"VALOR LISTA": item.user.creditor ? parseFloat(item.user.creditor.amount.toString()).toFixed(2) : 'N/A',
							"ENVIADO EM": this.$moment(item.created_at).format('DD.MM.YY'),
							"CLASSE NEGOCIO": (creditorTypes.find(type => type.id === value.type) || { name: "N/A" }).name,
							"ORIGEM NEGOCIO": value.origin,
							"NUMERO NEGOCIO": value.request_number ? value.request_number.replaceAll(";", '/') : '',
							"VALOR NEGOCIO": parseFloat(value.amount.toString()).toFixed(2),
							"DEVEDORA NEGOCIO": value.company_name,
							"DOCUMENTOS COMPROBATORIOS": docNames,
							"OBSERVAÇÃO NEGOCIO": value.observation ? value.observation.replaceAll(";", ' ').replaceAll("\n", " ").replaceAll("\r", " ").replaceAll("\r\n", " ") : '',
							"MOTIVO": this.cleanHtml(value.reason),

						};

						newData.push(data);
					}

				}

				if (!newData.length) {
					this.$dialog.notify.warning('Nenhum pedido encontrado baseado nos filtros selecionados!', {
						position: 'top-right',
						timeout: 2000
					})
					return;
				}

				const header = Object.keys(newData[0]);
				const csvContent = [header.join(';')];

				newData.forEach(item => {
					const row = header.map(key => {
						const value = item[key];
						return typeof value === 'object' && value !== null ? value.join(';') : value;
					}).join(';');
					csvContent.push(row);
				});

				const csv = csvContent.join('\r\n');

				const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
				const url = window.URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.setAttribute('href', url);
				link.setAttribute('download', 'Pedidos de habilitações e divergências.csv');
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);

				this.$dialog.notify.info("Arquivo CSV gerado com sucesso!", { position: "top-right", timeout: 2000 });

			} catch (error) {
				this.$dialog.notify.error(this.$codes(error), {
					position: 'top-right',
					timeout: 2000
				})
			} finally {
				this.loadingExport = false;
				this.showModal = false;
			}
			// const newData = result.data.content.data.map(obj => ({
			// 	"NR ORDEM": obj.id,
			// 	"CREDOR": obj.name,
			// 	"CPF/CNPJ": this.formatCpfCnpj(obj.registration),
			// 	"E-MAIL": obj.email,
			// 	"CASO": obj.client.name,
			// 	"VALOR": obj.amount ? obj.amount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : "N/A",
			// 	"CLASSE": obj.type === 1 ? "Classe I - Trabalhista" :
			// 		(obj.type === 2 ? "Classe II - Garantia Real" :
			// 			(obj.type === 3 ? "Classe III - Quirografários" :
			// 				(obj.type === 4 ? "Classe IV - ME/EPP" :
			// 					(obj.type === 5 ? "Extraconcursais" : "N/A")))),
			// 	"CRIADO EM": obj.created_at,

			// }));

			// try {

			// 	const header = Object.keys(newData[0]);
			// 	const csvContent = [header.join(';')];

			// 	newData.forEach(item => {
			// 		const row = header.map(key => {
			// 			const value = item[key];
			// 			return typeof value === 'object' && value !== null ? value.join(';') : value;
			// 		}).join(';');
			// 		csvContent.push(row);
			// 	});

			// 	const csv = csvContent.join('\r\n');

			// 	const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
			// 	const url = window.URL.createObjectURL(blob);
			// 	const link = document.createElement('a');
			// 	link.setAttribute('href', url);
			// 	link.setAttribute('download', 'QGC.csv');
			// 	document.body.appendChild(link);
			// 	link.click();
			// 	document.body.removeChild(link);

			// 	this.$dialog.notify.info("Arquivo CSV gerado com sucesso!", { position: "top-right", timeout: 2000 });

			// } catch (error) {
			// 	this.$dialog.notify.error(this.$codes(error), {
			// 		position: 'top-right',
			// 		timeout: 2000
			// 	})
			// }
		},

		formatCpfCnpj(value) {
			return value.length == 14 ? cnpj.format(value) : cpf.format(value);
		},

		cleanHtml(html) {
			if (!html) return "";

			let text = html.replace(/<[^>]*>/g, "");

			let temp = document.createElement("textarea");
			temp.innerHTML = text;
			return temp.value.trim();
		},

	},

};

</script>

<style lang="scss">
.icon-container {
	display: flex;
	align-items: center;
	border: 1px solid #ccc;
	padding: 10px;
	border-radius: 8px;
}

.btn-dropdown {
	font-weight: bold;
	border-radius: 12px;
}

.menu-item {
	transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

.menu-item:hover {
	background-color: #f5f5f5;
	box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
	cursor: pointer;
}

.v-menu__content {
	box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
}
</style>
